import { isStocksFunnel } from '../common/web/is-stocks-host'
import { checkRedirectURL } from '../common/web/check-url-with-domain'
import {
  getDomainUrl,
  getHostName,
  getINDStockDomainUrl,
  getINDStocksHostName,
} from '@/root/api/url-constants'
import { logNewRelicEvent } from '../common/custom/newrelic-page-events'
import { getOrSetSessionId } from './get-session-id'

// Post login function tailored for STENCIL
export const onLogin = (
  isNew = false,
  encryptedToken = '',
  returnTo = '',
  encryptedRefreshToken = '',
  userId = '',
) => {
  const { hostname } = window.location

  // Need to check if needed or not
  // -------------------------------------
  // if landed here via IND Quiz referral, handle it specially
  // const parsedReturnTo = "" // Utils.getPathNameAndQueryParamsFromReturnTo()
  // if (
  //   parsedReturnTo.pathName?.includes('/indpolls') &&
  //   parsedReturnTo.queryParams?.get('gift_code')
  // ) {
  //   const newForIndQuizReferral = !fName
  //   const indQuizReferralRedirectUrl = `${returnTo}&is_new=${newForIndQuizReferral}`
  //   if (newForIndQuizReferral) {
  //     window.localStorage.setItem(
  //       'IND_QUIZ_REFERRAL_REDIRECT_URL',
  //       indQuizReferralRedirectUrl,
  //     )
  //     window.location.href = '/onboarding-l1-sl1'
  //   } else {
  //     window.location.href = indQuizReferralRedirectUrl
  //   }
  //   return
  // }
  // -------------------------------------

  const domain = isStocksFunnel() ? getDomainUrl() : getINDStockDomainUrl()
  console.info('domain', {
    domain,
    stockFunnel: isStocksFunnel(),
    ind: getDomainUrl(),
  })
  const newDomain = isStocksFunnel() ? getINDStockDomainUrl() : getDomainUrl()
  const sessionId = getOrSetSessionId()
  // Global link for authenticating to other domain name like indstocks or indmoney when on authentication is proceeded from any one of them
  const globalLink = `${domain}?token=${encryptedToken}${
    encryptedRefreshToken ? `&refresh_token=${encryptedRefreshToken}` : ''
  }&session_id=${sessionId}&return_to=${
    hostname ? `https://${hostname}` : newDomain
  }`

  const getLogPayload = () => {
    return {
      tokenPresent: encryptedToken ? 'true' : 'false',
      refreshTokenPresent: encryptedRefreshToken ? 'true' : 'false',
      userId,
      targetDomain: domain,
    }
  }

  try {
    logNewRelicEvent('web_login_redirect_attempt', getLogPayload())
    // handling for new user to redirect them to onboarding flow
    if (isNew) {
      const hostName = isStocksFunnel() ? getINDStocksHostName() : getHostName()
      window.location.href = `${domain}?token=${encryptedToken}${
        encryptedRefreshToken ? `&refresh_token=${encryptedRefreshToken}` : ''
      }&return_to=${hostName}/onboarding-l1-sl1`
    } else if (returnTo && returnTo !== 'about:blank') {
      // Return to handling

      if (checkRedirectURL(returnTo) || returnTo.includes('logout')) {
        window.location.href = `${globalLink}${decodeURIComponent('/')}`
      } else if (returnTo.includes('dynamo_id')) {
        window.location.href = `${globalLink}${returnTo}`
      } else {
        logNewRelicEvent('web_login_redirect_returnto', getLogPayload())
        window.location.href = `${globalLink}${decodeURIComponent(returnTo)}`
      }
    } else {
      logNewRelicEvent('web_login_redirect_default', getLogPayload())
      // Default redirection after login
      window.location.href = `${globalLink}${decodeURIComponent('/dashboard')}`
    }
  } catch (error) {
    logNewRelicEvent('web_login_redirect_failure', {
      error: error?.message || 'Unknown error',
      userId,
      targetDomain: domain,
    })
    window.location.href = `${globalLink}${decodeURIComponent('/')} `
  }
}
